<template>
  <div class="locale-changer">
    <el-select v-model="selectedLanguage" size="default" placeholder="Select Language" @change="changeLanguage">
      <template #prefix>
        <i class="fas fa-globe" />
      </template>
      <el-option v-for="lang in supportedLanguages" :key="`${lang.name}`" :value="lang.code" :label="lang.name">
        {{ lang.name }}
      </el-option>
    </el-select>
  </div>
</template>

<script lang="ts">
import { ref, onMounted } from "vue"
import { useRoute } from "vue-router"
import { useI18n } from "vue-i18n"
import { useUpdateMember } from "@/composables/members"
import { useUserStore } from "@/store/user-store"
import { useI18nStore } from "@/store/i18n-store"

export default {
  setup() {
    const { locale } = useI18n()
    const { updateMember } = useUpdateMember()
    const userStore = useUserStore()
    const i18nStore = useI18nStore()

    const route = useRoute()
    const supportedLanguages = [
      { name: "English", code: "en" },
      { name: "Español", code: "es" }
    ]
    const selectedLanguage = ref<string | null>("en")

    onMounted(() => {
      // Check if "lang" query parameter exists
      if (route.query.lang) {
        changeLanguage(route.query.lang.toString())
        selectedLanguage.value = route.query.lang.toString()
      } else {
        locale.value = i18nStore.language
        selectedLanguage.value = i18nStore.language
      }
    })

    const changeLanguage = (lang: string) => {
      if (lang) {
        locale.value = lang
        i18nStore.setLanguage(lang)
        if (userStore.isLoggedIn) {
          updateMember({ memberId: userStore.memberId!, updateMemberRequest: { preferred_language: lang } })
        }
      }
    }

    return { selectedLanguage, supportedLanguages, changeLanguage }
  }
}
</script>

<style lang="sass">
.locale-changer
  width: 120px
</style>
